import { createComponent, createHook } from 'reakit-system';
import {
  color,
  ColorProps,
  compose,
  system,
  typography,
  TypographyProps,
} from 'styled-system';
import { StylesOptions, useStyles } from '../hooks/useStyles';
import { useTheme } from '../hooks/useTheme';
import { ecss, cx } from '../reexports/emotion';
import { Theme } from '@mos-cat/ds-theme';
import { BoxHTMLProps } from '../Box/Box';

import type { Property } from 'csstype';
import type { Component } from 'reakit-system/ts';

const textDecoration = system({
  textDecoration: true,
});
const WebkitTextFillColor = system({
  WebkitTextFillColor: {
    property: 'WebkitTextFillColor',
    scale: 'colors',
  },
});
let textScales = compose(
  typography,
  color,
  textDecoration,
  WebkitTextFillColor
);

export type TextOptions = TypographyProps<Theme> &
  ColorProps<Theme> & {
    textDecoration?: Property.TextDecoration;
    WebkitTextFillColor?: Property.WebkitTextFillColor;
  } & StylesOptions;

export type TextHTMLProps = BoxHTMLProps;

export type TextProps = TextOptions & TextHTMLProps;

export let useText = createHook<TextOptions, TextHTMLProps>({
  name: 'Text',
  keys: textScales.propNames,
  compose: [useStyles, useTheme],
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        props.className,
        ecss({ label: 'Text' }, textScales(options))
      ),
    };
  },
});

export let Text = createComponent({
  as: 'span',
  useHook: useText,
  memo: true,
});
